// Tab functionality
document.addEventListener("DOMContentLoaded", function () {
  const tabButtons = document.querySelectorAll(
    ".pregnancy-trimester-guide-section .tab-btn"
  );
  const tabContents = document.querySelectorAll(
    ".pregnancy-trimester-guide-section .tab-content"
  );

  function switchTab(targetTab) {
    // Remove active class from all tabs and content
    tabButtons.forEach((btn) => {
      btn.classList.remove("active");
      btn.setAttribute("aria-selected", "false");
    });

    tabContents.forEach((content) => {
      content.classList.remove("active");
    });

    // Add active class to clicked tab and corresponding content
    const activeButton = document.querySelector(
      `.pregnancy-trimester-guide-section [data-tab="${targetTab}"]`
    );
    const activeContent = document.querySelector(
      `.pregnancy-trimester-guide-section #${targetTab}-content`
    );

    if (activeButton && activeContent) {
      activeButton.classList.add("active");
      activeButton.setAttribute("aria-selected", "true");
      activeContent.classList.add("active");
    }
  }

  // Add click event listeners to tab buttons
  tabButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const targetTab = this.getAttribute("data-tab");
      switchTab(targetTab);
    });

    // Add keyboard support for tabs
    button.addEventListener("keydown", function (e) {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        const targetTab = this.getAttribute("data-tab");
        switchTab(targetTab);
      }
    });
  });

  // CTA button link handling
  const ctaBtn = document.querySelector(
    ".pregnancy-trimester-guide-section .cta-btn"
  );
  if (ctaBtn) {
    // Link will open in new tab automatically due to target="_blank"
    console.log("Shop link ready");
  }
});

// Function to toggle expandable sections
function toggleExpand(button) {
  const expandedContent = button.nextElementSibling;
  const isExpanded = button.classList.contains("expanded");

  if (isExpanded) {
    button.classList.remove("expanded");
    expandedContent.classList.remove("open");
    button.setAttribute("aria-expanded", "false");
  } else {
    button.classList.add("expanded");
    expandedContent.classList.add("open");
    button.setAttribute("aria-expanded", "true");
  }
}
